import { inject, Injectable } from '@angular/core';
import { IDialogContent } from '../interfaces/dialog-content.interface';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertDialog } from '../alert-dialog/alert-dialog';
import { ConfirmDialog } from '../confirm-dialog/confirm-dialog';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  private ngbModal = inject(NgbModal);

  public openAlert(content: IDialogContent): Promise<boolean> {
    return this.open(content, 'alert');
  }

  public openConfirm(content: IDialogContent): Promise<boolean> {
    return this.open(content, 'confirm');
  }

  private async open(content: IDialogContent, dialogType: 'confirm' | 'alert'): Promise<boolean> {
    const dialogTypes = {
      alert: AlertDialog,
      confirm: ConfirmDialog,
    };

    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }

    const modal = this.ngbModal.open(dialogTypes[dialogType], {
      backdrop: 'static',
    });

    modal.componentInstance.content = content;

    try {
      await modal.result;
      return true;
    } catch (error) {
      return false;
    }
  }
}
